import React from 'react';
import { useState } from 'react';
import BasketSelectionInterface from '../BasketSelectionInterface/BasketSelectionInterface';

const TopicActions = ({ isInBasket, onBasketChange, currentBasketId, topic, baskets }) => {
  const [showBasketSelection, setShowBasketSelection] = useState(false);

  const handleBasketActionClick = () => {
    setShowBasketSelection(true);
  };

  const handleBasketSelected = (basketId) => {
    onBasketChange(basketId);
    setShowBasketSelection(false);
  };

  return (
    <>
      <footer className="fixed bottom-0 left-0 right-0 p-4 bg-neutral-50">
        <div className="max-w-6xl mx-auto">
          <button 
            className="w-full rounded-xl bg-cranberry-700 text-white hover:bg-cranberry-600 py-3 font-semibold transition-colors duration-300"
            onClick={handleBasketActionClick}
          >
            {isInBasket ? "Move to another basket" : "Add to basket"}
          </button>
        </div>
      </footer>
      {showBasketSelection && (
        <BasketSelectionInterface
          onClose={() => setShowBasketSelection(false)}
          onBasketSelected={handleBasketSelected}
          currentBasketId={currentBasketId}
          topic={topic}
          workspaceId={topic.workspace_id}
        />
      )}
    </>
  );
};

export default TopicActions;
